/**
 * @param arrayOfAuthPermissions - permissions issued after successful authentication
 * @param requiredPermissions - the permissions we are trying to verify of they are owned
 * @returns {boolean} true if at least one of the permissions in requiredPermissions is included in arrayOfAuthPermissions,
 * false otherwise.
 */
export function hasSomePermissions(arrayOfAuthPermissions, requiredPermissions) {
  for (const permission in arrayOfAuthPermissions) {
    if (requiredPermissions.includes(arrayOfAuthPermissions[permission])) {
      return true;
    }
  }

  return false;
}
